module.exports = __webpack_public_path__ + "static/media/sign-up-update.3ff125e4.png";